import Immutable from 'immutable'
import GroupMenu from './group_menu'

export default class GroupMenuWithOrders extends GroupMenu
  isSaved: ->
    @_courseMenus.every (courseMenu) -> courseMenu.isSaved()

  hasSelection: ->
    @_courseMenus.some (courseMenu) -> courseMenu.hasSelection()

  isLocked: ->
    @isAfterDeadline() or @selectionForOtherCanteensExists()

  ordersForOtherCanteensExist: ->
    @__ordersForOtherCanteensExist ?=
      @_menu.groupMenusForCanteens(@date, @group)
        .delete(@canteen.id)
        .some (groupMenu) -> groupMenu.hasOrders()

  selectionForOtherCanteensExists: ->
    @__selectionForOtherCanteensExists ?=
      @_menu.groupMenusForCanteens(@date, @group)
        .delete(@canteen.id)
        .some (groupMenu) -> groupMenu.hasSelection()

  hasOrders: ->
    @_courseMenus.some (courseMenu) -> courseMenu.savedMealNumber?

  orders: ->
    if @_courseMenus
      @_courseMenus
        .filter (courseMenu) -> (not courseMenu.isSaved()) or courseMenu.hasSelection()
        .map (courseMenu, courseName) ->
          { course: courseName, number: courseMenu.selectedMealNumber }
        .valueSeq().toArray()
    else
      []

  allAdditionalMealsSelected: ->
    @__allAdditionalMealsSelected ?= @_allAdditionalMealsSelected()

  _allAdditionalMealsSelected: ->
    selectedMeals = @selectedMeals()
    selectedMeals.every (mainMeal) ->
      not mainMeal.hasAdditional() or \
        selectedMeals.some (additionalMeal) ->
          additionalMeal.courseName == mainMeal.additionalCourseName

  selectedMeals: ->
    if @_courseMenus then @constructor.selectedMeals(@_courseMenus) else new Immutable.List

  @selectedMeals: (courseMenus) ->
    courseMenus
      .filter (courseMenu) -> courseMenu.selectedMealNumber
      .map (courseMenu) ->
        courseMenu.meals.find (meal) -> meal.number == courseMenu.selectedMealNumber
      .valueSeq()
